import React, { PropsWithChildren } from "react";
import { useSelector } from "react-redux";
import { selectIsLoggedIn } from "../../store/user";
import { Navigate } from "react-router-dom";

const PrivateRoute = (props: PropsWithChildren): React.ReactElement => {
  const { children } = props;
  const isLoggedIn = useSelector(selectIsLoggedIn);

  return isLoggedIn ? <>{children}</> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
